import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

import { getAllDetails, postAllData } from '../../../service/ProductService';
import { ADD_UPDATE_REFRESHER_COURSE, GET_COLLEGES, GET_REFRESHER_COURSE } from '../../../config/ApiConstant';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { convertDateFrom, defaultSlotOptions } from '../../../appconfig/Settings';
import { AddUpdateOnlineRefresherCourseValidate } from '../../../config/Validate';
import Loader from '../../../components/Loadeer/Loader';

export const AddUpdateOnlineRefresherCourse = () => {
    document.title = 'Add / Edit Online Refresher Course | GSPC';

    // Parameters
    const { courseId }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [collegesList, setCollegesList] = useState<any>([]);
    const [courseDetails, setCourseDetails] = useState<any>({
        start_date: new Date(),
        end_date: new Date(new Date().setHours(23, 59, 59, 999)),
        total_slot: defaultSlotOptions[1],
        lec_1: {},
        lec_2: {},
        lec_3: {},
        lec_4: {},
        lec_5: {},
        lec_6: {},
        lec_7: {},
        lec_8: {},
    });
    const [errors, setErrors] = useState<any>({});
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);

    // console.log(courseDetails, 'courseDetails');
    
    // useEffect
    useEffect(() => {
        getColleges();

        if (!window.cn(courseId)) {
            setIsEditOpen(true);
            getCourseById(courseId);
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get Course BY ID
    const getCourseById = async (courseId: any) => {
        try {
            setPageLoad(true);
            const response = await getAllDetails(GET_REFRESHER_COURSE + '?id=' + atob(courseId));
            if (response) {
                const {
                    refresher_course_name,
                    college,
                    start_date,
                    end_date,
                    total_slot,
                    contact_person_1_email,
                    contact_person_1_mobile,
                    contact_person_1_name,
                    contact_person_2_email,
                    contact_person_2_mobile,
                    contact_person_2_name,
                    lec_1,
                    lec_2,
                    lec_3,
                    lec_4,
                    lec_5,
                    lec_6,
                    lec_7,
                    lec_8,
                    exam_date,
                    exam_time
                } = response;
                
                const totalSlot = defaultSlotOptions.find((slot) => slot?.code === total_slot);
                setCourseDetails({
                    refresher_course_name: refresher_course_name,
                    college_id: { name: college?.orgnameeng, code: college?.orgcode },
                    start_date: new Date(start_date),
                    end_date: new Date(end_date),
                    total_slot: totalSlot,
                    contact_person_1_email: contact_person_1_email,
                    contact_person_1_mobile: contact_person_1_mobile,
                    contact_person_1_name: contact_person_1_name,
                    contact_person_2_email: contact_person_2_email,
                    contact_person_2_mobile: contact_person_2_mobile,
                    contact_person_2_name: contact_person_2_name,

                    lec_1: !window.cn(lec_1) ? JSON.parse(lec_1) : {},
                    lec_2: !window.cn(lec_2) ? JSON.parse(lec_2) : {},
                    lec_3: !window.cn(lec_3) ? JSON.parse(lec_3) : {},
                    lec_4: !window.cn(lec_4) ? JSON.parse(lec_4) : {},
                    lec_5: !window.cn(lec_5) ? JSON.parse(lec_5) : {},
                    lec_6: !window.cn(lec_6) ? JSON.parse(lec_6) : {},
                    lec_7: !window.cn(lec_7) ? JSON.parse(lec_7) : {},
                    lec_8: !window.cn(lec_8) ? JSON.parse(lec_8) : {},

                    exam_date: !window.cn(exam_date) ? new Date(exam_date) : null,
                    exam_time: !window.cn(exam_time) ? exam_time : ''
                });
                setPageLoad(false);
            }
        } catch (error: any) {
            if (error.response) {
                setCollegesList([]);
                setPageLoad(false);

                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Get colleges
    const getColleges = async () => {
        try {
            const response = await getAllDetails(GET_COLLEGES + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCollegesList([]);
                } else {
                    let collegeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegeData.push(collegeObj);
                    }
                    setCollegesList(collegeData);
                }
            } else {
                setCollegesList([]);
            }
        } catch (error: any) {
            setCollegesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        // set end date if new date is > end date

        if (name === 'college_id' || name === 'total_slot') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        if (name === 'start_date') {
            if (val > new Date(courseDetails.end_date)) {
                courseDetails.end_date = new Date(new Date(val).setHours(23, 59, 59, 999));
            }
        }
        // set hours on end date change
        if (name === 'end_date') {
            courseDetails.end_date = new Date(new Date(val).setHours(23, 59, 59, 999));
        }

        setCourseDetails({ ...courseDetails, [name]: val });
    };

    // Copy text
    const copyText = (text: any) => {
        navigator.clipboard.writeText(text);
        toast.current?.show({
            severity: 'success',
            summary: 'Text copied to clipboard',
            detail: ''
        });
    };

    // On change course data
    const onChangeCourseData = (key: any, name: any, e: any) => {
        let lect = courseDetails[key];
        let val = (e.target && e.target.value) || e.value || '';
        lect[name] = val;
        console.log(name, 'name');

        setCourseDetails({ ...courseDetails, [key]: lect });
    };

    // Get sesion ui
    const getSessionIU = () => {
        let sessionData: any = [];
        for (let i = 1; i <= 8; i++) {
            sessionData.push(
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="session_title">Session {i} Title</label>
                        <div className="input-effect-div">
                            <InputText
                                value={courseDetails['lec_' + i]?.title}
                                autoComplete="off"
                                id="session_title"
                                onChange={(e) => onChangeCourseData('lec_' + i, 'title', e)}
                                className={errors['title'] && 'p-invalid'}
                                disabled={isEditOpen === false ? false : true}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="speaker_title">Speaker {i} Title</label>
                        <div className="input-effect-div">
                            <InputText
                                value={courseDetails['lec_' + i]?.speaker_name}
                                autoComplete="off"
                                id="speaker_name"
                                onChange={(e) => onChangeCourseData('lec_' + i, 'speaker_name', e)}
                                className={errors['name'] && 'p-invalid'}
                                disabled={isEditOpen === false ? false : true}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="session_link">Session {i} Zoom Link</label>
                        <div className="input-effect-div">
                            <InputText
                                value={courseDetails['lec_' + i]?.link}
                                autoComplete="off"
                                id="link"
                                onChange={(e) => onChangeCourseData('lec_' + i, 'link', e)}
                                className={errors['link'] && 'p-invalid'}
                                disabled={isEditOpen === false ? false : true}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-1 mt-4">
                        <Button className="p-button-secondary" icon="pi pi-copy" onClick={() => copyText(courseDetails['lec_' + i]?.link)} />
                    </div>

                    <div className="field col-12 md:col-2">
                        <label htmlFor="session_link">Session {i} Start Date & Time</label>
                        <div className="input-effect-div">
                            <Calendar
                                value={!window.cn(courseDetails['lec_' + i]?.date_time) ? new Date(courseDetails['lec_' + i]?.date_time) : courseDetails['lec_' + i]?.date_time}
                                id="date_time"
                                showTime
                                hourFormat="12"
                                onChange={(e) => onChangeCourseData('lec_' + i, 'date_time', e)}
                                className={errors['date_time'] && 'p-invalid'}
                                disabled={window.cn(courseDetails['lec_' + i]?.link) ? true : isEditOpen}
                                showIcon
                                dateFormat="dd-M-yy"
                                minDate={new Date(courseDetails?.start_date)}
                                maxDate={new Date(courseDetails?.end_date)}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>
            );
        }
        return sessionData;
    };

    // Add update course
    const addUpdateCourse = async () => {
        try {
            const { errors, isError } = AddUpdateOnlineRefresherCourseValidate(courseDetails);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                let requestData = courseDetails;
                if (!window.cn(courseId)) {
                    requestData['id'] = atob(courseId);
                }

                requestData['college_id'] = courseDetails?.college_id?.code;
                requestData['total_slot'] = courseDetails?.total_slot?.code;
                requestData['start_date'] = convertDateFrom(courseDetails?.start_date);
                requestData['end_date'] = convertDateFrom(courseDetails?.end_date);
                requestData['lec_1'] = JSON.stringify(courseDetails['lec_1']);
                requestData['lec_2'] = JSON.stringify(courseDetails['lec_2']);
                requestData['lec_3'] = JSON.stringify(courseDetails['lec_3']);
                requestData['lec_4'] = JSON.stringify(courseDetails['lec_4']);
                requestData['lec_5'] = JSON.stringify(courseDetails['lec_5']);
                requestData['lec_6'] = JSON.stringify(courseDetails['lec_6']);
                requestData['lec_7'] = JSON.stringify(courseDetails['lec_7']);
                requestData['lec_8'] = JSON.stringify(courseDetails['lec_8']);

                //apicall
                const response = await postAllData(ADD_UPDATE_REFRESHER_COURSE, requestData);
                if (response && !window.cn(response)) {
                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        navigate('/app/refresher-course-list');
                    }, 1500);
                }
            }
        } catch (error: any) {
            setAddUpdateLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Alert',
                detail: error?.response?.data?.error
            });
        }
    };

    // Enable edit
    const enableEdit = () => {
        setIsEditOpen(false);
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Refresher Course'} pageName={window.cn(courseId) ? 'Add Online Course' : 'View Online Course'} pageTitle={window.cn(courseId) ? 'Add Online Course' : 'View Online Course'} goToPage={true} />

            <div className="card">
                <p>
                    <b>Add Refresher Course Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="refresher_course_name">
                            Refresher Course Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText
                                value={courseDetails?.refresher_course_name}
                                autoComplete="off"
                                id="refresher_course_name"
                                onChange={(e) => onInputChange(e, 'refresher_course_name')}
                                className={errors['refresher_course_name'] && 'p-invalid'}
                                disabled={isEditOpen === false ? false : true}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['refresher_course_name']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="college_id">
                            College Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={courseDetails?.college_id}
                                name="college_id"
                                options={collegesList}
                                filter
                                optionLabel="name"
                                placeholder="Select College"
                                onChange={(e) => onInputChange(e.value, 'college_id')}
                                className={errors['college_id'] && 'p-invalid'}
                                disabled={isEditOpen === false ? false : true}
                            />
                        </div>
                        <small className="p-invalid-txt">{errors['college_id']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="start_date">
                            Start Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Calendar
                            value={!window.cn(courseDetails?.start_date) && courseDetails?.start_date}
                            onChange={(e) => onInputChange(e, 'start_date')}
                            dateFormat="dd-M-yy"
                            minDate={new Date()}
                            disabled={isEditOpen === false ? false : true}
                            showIcon
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="end_date">
                            End Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Calendar
                            // value={!window.cn(courseDetails?.end_date) && courseDetails?.end_date}
                            value={!window.cn(courseDetails.start_date) ? new Date(new Date(courseDetails?.end_date).setHours(23, 59, 59, 999)) : null}
                            onChange={(e) => onInputChange(e, 'end_date')}
                            dateFormat="dd-M-yy"
                            minDate={new Date(courseDetails?.start_date)}
                            disabled={isEditOpen === false ? false : true}
                            showIcon
                        />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="total_slot">
                            Total Slots <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={courseDetails?.total_slot}
                                name="total_slot"
                                options={defaultSlotOptions}
                                filter
                                optionLabel="name"
                                placeholder="Select Total Slots"
                                onChange={(e) => onInputChange(e.value, 'total_slot')}
                                className={errors['total_slot'] && 'p-invalid'}
                                disabled={isEditOpen === false ? false : true}
                            />
                        </div>
                        <span className="focus-bg"></span>
                    </div>
                </div>
                <hr />
                <p>
                    <b>Add Contact Person Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="col-12 md:col-6">
                        <p>
                            <b>Contact Person 1</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="contact_person_1_name">
                                Name <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputText
                                    value={courseDetails?.contact_person_1_name}
                                    autoComplete="off"
                                    id="contact_person_1_name"
                                    onChange={(e) => onInputChange(e, 'contact_person_1_name')}
                                    className={errors['contact_person_1_name'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? false : true}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['contact_person_1_name']}</small>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="contact_person_1_email">
                                Email <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputText
                                    value={courseDetails?.contact_person_1_email}
                                    autoComplete="off"
                                    id="contact_person_1_email"
                                    onChange={(e) => onInputChange(e, 'contact_person_1_email')}
                                    className={errors['contact_person_1_email'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? false : true}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['contact_person_1_email']}</small>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="contact_person_1_mobile">
                                Mobile <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="input-effect-div">
                                <InputText
                                    keyfilter={'num'}
                                    value={courseDetails?.contact_person_1_mobile}
                                    autoComplete="off"
                                    id="contact_person_1_mobile"
                                    onChange={(e) => onInputChange(e, 'contact_person_1_mobile')}
                                    className={errors['contact_person_1_mobile'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? false : true}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['contact_person_1_mobile']}</small>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <p>
                            <b>Contact Person 2</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="contact_person_2_name">Name</label>
                            <div className="input-effect-div">
                                <InputText
                                    value={courseDetails?.contact_person_2_name}
                                    autoComplete="off"
                                    id="contact_person_2_name"
                                    onChange={(e) => onInputChange(e, 'contact_person_2_name')}
                                    className={errors['contact_person_2_name'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? false : true}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['contact_person_2_name']}</small>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="contact_person_2_email">Email</label>
                            <div className="input-effect-div">
                                <InputText
                                    value={courseDetails?.contact_person_2_email}
                                    autoComplete="off"
                                    id="contact_person_2_email"
                                    onChange={(e) => onInputChange(e, 'contact_person_2_email')}
                                    className={errors['contact_person_2_email'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? false : true}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['contact_person_2_email']}</small>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="contact_person_2_mobile">Mobile</label>
                            <div className="input-effect-div">
                                <InputText
                                    value={courseDetails?.contact_person_2_mobile}
                                    autoComplete="off"
                                    id="contact_person_2_mobile"
                                    onChange={(e) => onInputChange(e, 'contact_person_2_mobile')}
                                    className={errors['contact_person_2_mobile'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? false : true}
                                />
                                <span className="focus-bg"></span>
                            </div>
                            <small className="p-invalid-txt">{errors['contact_person_2_mobile']}</small>
                        </div>
                    </div>
                </div>
                <hr />
                <p>
                    <b>Add Session Details</b>
                </p>
                {getSessionIU()}

                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="exam_date">Exam Date & Time</label>
                        <div className="input-effect-div">
                            <Calendar
                                value={courseDetails?.exam_date}
                                id="exam_date"
                                showTime
                                hourFormat="12"
                                onChange={(e) => onInputChange(e, 'exam_date')}
                                className={errors['exam_date'] && 'p-invalid'}
                                minDate={new Date(new Date(courseDetails?.end_date).setHours(0, 0, 0, 1))}
                                disabled={isEditOpen === false ? false : true}
                                showIcon
                                dateFormat="dd-M-yy"
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="exam_time">Exam Duration</label>
                        <div className="input-effect-div">
                            <InputText value={courseDetails?.exam_time} autoComplete="off" id="exam_time" onChange={(e) => onInputChange(e, 'exam_time')} className={errors['exam_time'] && 'p-invalid'} disabled={isEditOpen === false ? false : true} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right' }}>
                            <Button label="Cancel" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => navigate('/app/refresher-course-list')} />

                            <Button label={window.cn(courseId) ? 'Add' : isEditOpen ? 'Edit' : 'Update'} icon="pi pi-check" onClick={isEditOpen === false ? () => addUpdateCourse() : () => enableEdit()} loading={addUpdateLoader} />
                        </div>
                    </div>
                </div>
            </div>
            {pageLoad === true && <Loader />}
        </>
    );
};
